(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSnomedController', RcopiaSnomedController);

    RcopiaSnomedController.$inject = ['$scope', '$state', 'RcopiaSnomed', 'RcopiaSnomedSearch'];

    function RcopiaSnomedController ($scope, $state, RcopiaSnomed, RcopiaSnomedSearch) {
        var vm = this;

        vm.rcopiaSnomeds = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            RcopiaSnomed.query(function(result) {
                vm.rcopiaSnomeds = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            RcopiaSnomedSearch.query({query: vm.searchQuery}, function(result) {
                vm.rcopiaSnomeds = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();
